module.exports = __webpack_public_path__ + "static/fullLogo-5b78c9216579a120cf8d99e8824b5f6a.svg";